import React from "react";

import SiteHeader from "components/layout/SiteHeader";
import { Mark } from "components/layout/Logo";
import { FRONT_URL as FRONT } from "lib/config";

// Log in / Sign up shell in the layout of Figma frame 4:2354 (Mekari
// University login): grey page, 440px white card with the logo top-left,
// links under the card, then the wordmark and copyright.
// Styles: styles/auth.css (.yc-auth-*).
export function AuthLogo({ size = 40 }) {
  return (
    <a href={FRONT} className="yc-auth-logo" aria-label="Youwdin Class home">
      <Mark size={size} />
      <span>
        <small>youwdin</small>
        <b>class</b>
      </span>
    </a>
  );
}

export default function AuthLayout({ title, children }) {
  return (
    <div className="yc-auth">
      <SiteHeader />
      <main className="yc-auth-main">
        <div className="yc-auth-card">
          <AuthLogo />
          {title && <h1 className="sr-only">{title}</h1>}
          {children}
        </div>

        <nav className="yc-auth-links" aria-label="More">
          <a href={`${FRONT}/courses`}>Browse classes</a>
          <span aria-hidden="true" />
          <a href={FRONT}>Home</a>
        </nav>
        <div className="yc-auth-brand">
          <AuthLogo size={24} />
        </div>
        <p className="yc-auth-copy">© {new Date().getFullYear()} Youwdin Class</p>
      </main>
    </div>
  );
}
